/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetListForPublication } from '../fn/admin-publications-controller/admin-get-list-for-publication';
import { AdminGetListForPublication$Params } from '../fn/admin-publications-controller/admin-get-list-for-publication';
import { ItemPublicationWithRelations } from '../models/item-publication-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminPublicationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemPublicationControllerAdminGetListForPublication()` */
  static readonly ItemPublicationControllerAdminGetListForPublicationPath = '/admin/publications/{id}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetListForPublication()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForPublication$Response(params: AdminGetListForPublication$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemPublicationWithRelations>>> {
    return adminGetListForPublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetListForPublication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForPublication(params: AdminGetListForPublication$Params, context?: HttpContext): Observable<Array<ItemPublicationWithRelations>> {
    return this.adminGetListForPublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemPublicationWithRelations>>): Array<ItemPublicationWithRelations> => r.body)
    );
  }

}
